import Splide from '@splidejs/splide'

const sliders = {
  init() {
  this.setHeroSliders()
  this.newArrivalProds()
  this.brands()  
  this.catSliders()
  this.prodSliders()
  this.setProdThumbnailsSlider()
  this.resetSlider()
  },


    resetSlider() {
    window.addEventListener("reset", () => {
      this.setProdThumbnailsSlider()
    })
  }, 

  setHeroSliders() {
    const heroSliders = document.querySelectorAll(".jsHeroSlide") as NodeListOf<HTMLElement>
    heroSliders.forEach((el) => {
      const slider = new Splide(el, {
        perPage: 1,
        type: 'loop',
        arrows: true,
        pagination: true,
      })
      slider.mount()
    })
  },

    newArrivalProds() {
    const slider = document.getElementById('jsArrivalsSlider') as HTMLElement | undefined

    if (slider) {
      new Splide(slider, {
        type: 'carousel',
        arrows: true,
        pagination: false,
        speed: 1200,
        
        gap: '37px',
        perMove: 1,
        perPage: 5,
        
        breakpoints: {
          1400: {
            perPage: 3,
         
          },

          990: {
            perPage: 3,
         
          },

          768: {
            perPage: 2,
            arrow: false,
           
          },

          500: {
            perPage: 1,
            arrow: false,
            padding:{right: '30%'},
            gap: '15px',
            arrows: false,
          
          },
        },
      }).mount()
    }
  },

      brands() {
    const slider = document.getElementById('jsBrandsSlider') as HTMLElement | undefined

    if (slider) {
      new Splide(slider, {
        type: 'carousel',
        arrows: true,
        pagination: false,
        speed: 1200,
        perMove: 1,
        gap: '28px',

        perPage: 7,

          breakpoints: {
          1400: {
            perPage: 4,
         
          },

          990: {
            perPage: 4,
         
          },

          768: {
            perPage: 2,
            padding: {right: '30%'},
            arrows: false,
           
          },

          500: {
            perPage: 2,
            padding: {right: '30%'},
            arrows: false,
            gap: '15px',
            perMove: 1,
          
          },
        },
        
      }).mount()
    }
  },

  catSliders() {
    const slider = document.getElementById('jsCatSliders') as HTMLElement | undefined

    if (slider) {
      new Splide(slider, {
        type: 'carousel',
        arrows: true,
        pagination: false,
        center: true,
        perPage: 7, 
        perMove: 1,
        speed: 1200,
        gap: '33px',
          breakpoints: {
          1400: {
            perPage: 4,
         
          },

          990: {
            perPage: 4,
         
          },

          768: {
            perPage: 2,
            padding:{right: '30%'},
            arrows: false,
            
           
          },

          500: {
            perPage: 1,
            padding:{right: '30%'},
            arrows: false,
            perMove: 1,
          
          
          },
        },
        
      }).mount()
    }
  },

  prodSliders() {
    const slider = document.querySelectorAll('.jsProdSliders') as NodeListOf<
      HTMLElement
    >

    slider.forEach((slide) => {
      new Splide(slide, {
        type: 'carousel',
        arrows: true,
        pagination: false,
        gap: '37px',
        perMove: 1, 
        perPage: 5,
        speed: 1200, 

        
        breakpoints: {
          1400: {
            perPage: 3,
         
          },

          990: {
            perPage: 3,
         
          },

          768: {
            perPage: 2,
            arrow: false,
           
          },

          500: {
            perPage: 1,
            padding: {right: '30%'},
            arrows: false,
            gap: '15px',
            perMove: 1,

          
          },
        },
      }).mount()
    })
  },

      setProdThumbnailsSlider() {
    const porductMainImages = document.getElementById("mainImage") as HTMLElement | undefined
    const thumbnails = document.getElementById("thumbnails") as HTMLElement | undefined

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: 'carousel',
        
        pagination: true,
        arrows: true,
      
      })

      const thumbnailsNav = new Splide(thumbnails, {
        
        isNavigation: true,
        type: 'carousel',
        pagination: false,
        heightRatio: 4,
        perPage: 4,
        arrows: false,
        gap: "20px",
        
        breakpoints: {
          767: {
            direction: "ltr",
            perPage: 3,
            heightRatio: 1,
            fixedHeight: "70px",
          },
        },
      })

      main.sync(thumbnailsNav)
      main.mount()
      thumbnailsNav.mount()
    }
  },
  
}

export default sliders
